export const IconDownload = ({size = 18}: { size?: number }) => {
    return <svg width={size} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.79541 0.904785V17.314M8.79541 17.314L0.59082 9.10938M8.79541 17.314L17 9.10938" stroke="currentColor"/>
        <path d="M0.59082 20.9604H17" stroke="currentColor"/>
    </svg>

}